'use strict'

angular
  .module('basalteApp')
  .constant('BAS_HOME', {
    NO_SOURCE: -9999,
    NO_SOURCE_UUID: 'no_source',
    ERR_NO_SERVERS: 'errNoServers'
  })
